import React from "react";

const RepairInquiriesCard = ({ title, desc, icons, status, onCardSelect }) => {
  const handleCheckboxChange = (e) => {
    onCardSelect(e.target.checked);
  };

  return (
    <div className="card">
      <div className="header_area">
        <h4>
          <input type="checkbox" className="checkBox" onChange={handleCheckboxChange}/>
          {title}
        </h4>
      </div>
      <p className="mt-2">{desc}</p>
      <hr className="mt-4" />
      <div className="mt-3">
        <p className="status">
          {icons} <span>{status}</span>
        </p>
      </div>
    </div>
  );
};

export default RepairInquiriesCard;
